import { useCurrentUser } from "hooks/auth";

interface EvaluationInviteEmailContentProps {
	companyName: string;
	rfxTitle: string;
	senderName?: string;
	deadline: string;
	additionalMessage?: string;
}

export const EvaluationInviteEmailContent: React.FC<EvaluationInviteEmailContentProps> = ({
	companyName,
	rfxTitle,
	deadline,
	additionalMessage,
}) => {
	const { currentUser } = useCurrentUser();
	const tdStyle: React.CSSProperties = {
		fontFamily: "Arial, sans-serif",
		fontSize: "16px",
		lineHeight: "24px",
		color: "#374151",
		paddingBottom: "20px",
	};

	return (
		<table
			width="100%"
			style={{ backgroundColor: "#ffffff" }}
		>
			<tbody>
				<tr>
					<td align="center">
						<table
							width="600"
							style={{ maxWidth: "600px" }}
						>
							<tbody>
								<tr>
									<td
										style={{
											...tdStyle,
											paddingTop: "40px",
										}}
									>
										Hi [Panel Member Name],
									</td>
								</tr>
								<tr>
									<td style={tdStyle}>
										You have been invited to join the evaluation panel for{" "}
										<strong>{rfxTitle || "[RFx Title]"}</strong> by{" "}{currentUser.full_name && <><strong>{currentUser.full_name}</strong> from{" "}</>}
										<strong>{companyName || "[Company Name]"}</strong>.
									</td>
								</tr>
								<tr>
									<td style={tdStyle}>
										As a panel member, you will be asked to review and score
										supplier submissions against the defined evaluation criteria.
									</td>
								</tr>
								<tr>
									<td style={tdStyle}>
										Please complete your evaluation by:
										<div style={{ marginTop: "12px" }}>
											<strong>{deadline || "[Deadline]"}</strong>
										</div>
									</td>
								</tr>
								{additionalMessage && (
									<tr>
										<td
											style={{
												...tdStyle,
												backgroundColor: "#F9FAFB",
												padding: "12px 16px",
												borderLeft: "4px solid #3B82F6",
												borderRadius: "4px",
											}}
										>
											<span
												style={{
													fontSize: "14px",
													fontWeight: 600,
													color: "#6B7280",
													display: "block",
													marginBottom: "4px",
												}}
											>
												Message from the inviter:
											</span>
											{additionalMessage}
										</td>
									</tr>
								)}
								<tr>
									<td style={tdStyle}>
										<span
											style={{
												display: "inline-block",
												backgroundColor: "#2563EB",
												color: "#ffffff",
												padding: "12px 24px",
												borderRadius: "6px",
												textDecoration: "none",
												fontWeight: 600,
												fontSize: "14px",
												cursor: "default",
											}}
										>
											View Evaluation
										</span>
									</td>
								</tr>
								<tr>
									<td style={tdStyle}>
										Should you have any questions, feel free to contact the
										evaluation lead directly.
									</td>
								</tr>
								<tr>
									<td
										style={{
											fontFamily: "Arial, sans-serif",
											fontSize: "16px",
											lineHeight: "24px",
											color: "#374151",
										}}
									>
										<br />
										Best Regards,
										<br />
										<br />
										<b>The Procuracon Team</b>
										<br />
										<i>Supporting transparent and efficient procurement</i>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
	);
};
